import React, { useRef } from 'react'
import { useTranslate, useRecordContext } from 'react-admin'
import { Box, Typography, Dialog, DialogContent, Button, DialogActions, DialogTitle } from '@mui/material'
import { Download } from '@mui/icons-material';


export const AditionalInfoModal = ({ open, handleClose }) => {
  const record = useRecordContext()
  const info = record?.itinerary
  const boxRef = useRef(null);
  const translate = useTranslate()

  const handleDownload = () => {
    const text = boxRef.current.innerText;

    const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "tour_information.txt";
    a.click();

    URL.revokeObjectURL(url);
  };

  if (
    info &&
    Array.isArray(info) &&
    info.length > 0
  ) {

    return (
      <Dialog open={open} maxWidth='lg' fullWidth={true} onClose={handleClose}>
        <DialogTitle>
            <Typography variant='h6' component='div' textAlign={'center'}>
              {translate('ra.field.aditional_information')}
            </Typography>
        </DialogTitle>
        <DialogContent>
            <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                <Download style={{cursor:'pointer'}} onClick={handleDownload}/>
            </div>
          <Box ref={boxRef} style={{ border: '4px solid #F9F9FD', borderRadius: '10px', padding: 10 }}>
            {info.map((elem, key) => (
              <div key={key}>
                <div style={{display:'flex', flexDirection:'column'}}>
                    <label style={{fontWeight:'bold'}}>
                        {translate('ra.field.day')}
                    </label>
                    <label>
                        {elem.day}
                    </label>
                </div>
                <div style={{display:'flex', flexDirection:'column'}}>
                    <label style={{fontWeight:'bold'}}>
                        {translate('ra.field.cities')}
                    </label>
                    <label>
                        {elem.cities?.join(', ')}
                    </label>
                </div>
                <div style={{display:'flex', flexDirection:'column'}}>
                    <label style={{fontWeight:'bold'}}>
                        {translate('ra.field.description')}
                    </label>
                    <label>
                        {elem.description}
                    </label>
                    <hr />
                </div>
              </div>
            ))}
          </Box>
          <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
            <Button onClick={handleClose} variant='outlined' color='error'>
              {translate('ra.action.close')}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    )
  }
  return null;
}
